// import the bootstrap.js and popper.js files from the node_modules
//import bootstrap from 'bootstrap';
const bootstrap = require('bootstrap');
export default () => {
  /*
  if (document.querySelector('[data-party-toggle]')) {
    apos.util.onReady(() => {
      const partyToggle = document.querySelector('[data-party-toggle]');

      partyToggle.addEventListener('click', engagePartyMode);

      function engagePartyMode () {
        // Party.
      }
    });
  }
  */
}

